import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import PropTypes from "prop-types";
import { SignOut } from "@phosphor-icons/react";

const PermissoesModal = ({ isOpen, toggle, permissions }) => {
	return (
		<Modal isOpen={isOpen} toggle={toggle} centered>
			<ModalBody>
				<h5>Permissões do Usuário</h5>
				{permissions && permissions.length > 0 ? (
					permissions.map((permission, index) => {
						const companyName = permission?.company?.name;
						const permissionName = permission?.permission?.name;

						if (companyName && permissionName) {
							return (
								<div
									key={index}
									className="d-flex flex-row mb-2"
								>
									<div className="col-6 fw-bold">
										{companyName}:
									</div>
									<div className="col-6 text-center">
										{permissionName}
									</div>
								</div>
							);
						}
						return null;
					})
				) : (
					<p className="text-muted">Nenhuma permissão encontrada.</p>
				)}
				<div style={{ display: "flex", justifyContent: "center" }}>
					<Button
						style={{
							background: "none",
							padding: 10,
							cursor: "pointer",
							color: "black",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							gap: 2,
							marginTop: 10,
						}}
						onClick={toggle}
					>
						<SignOut size={16} /> Fechar
					</Button>
				</div>
			</ModalBody>
		</Modal>
	);
};

PermissoesModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	toggle: PropTypes.func.isRequired,
	permissions: PropTypes.array,
};

export default PermissoesModal;
